import { render, staticRenderFns } from "./AddRecordButton.vue?vue&type=template&id=65c5b0f4"
import script from "./AddRecordButton.vue?vue&type=script&lang=js"
export * from "./AddRecordButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports